import { useState } from 'react';
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { columns } from './columns';
import { FooterCell } from '../Table/FooterCell';
import { VariantEditPanel } from './VariantEditPanel';
import { useProductVariantContext } from '../../context/hooks/useProductVariant';

export const Table = () => {
  const { data, setData, setOriginalData, pageCount } = useProductVariantContext();
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [expandedIndex, setExpandedIndex] = useState(null);

  const table = useReactTable({
    data,
    columns,
    pageCount,
    state: { pagination },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    manualPagination: true,

    meta: {
      expandedIndex,
      toggleExpand: (rowIndex) => {
        setExpandedIndex((prev) => (prev === rowIndex ? null : rowIndex));
      },
      updateRow: (rowIndex, updatedRow) => {
        setData((old) => old.map((row, i) => (
          i === rowIndex ? { ...row, ...updatedRow } : row
        )));
        setOriginalData((old) => old.map((row, i) => (
          i === rowIndex ? { ...row, ...updatedRow } : row
        )));
        setExpandedIndex(null);
      },
      addRow: () => {
        const newRow = {
          variantCode: "", variantImage: "", variantName: "", description: "",
          vol: "", alcohol_percentage: 0, purchasePrice: 0, quantity: 0,
          storePricing: [], isTopSellingProduct: false, offers: [],
          isOfferApplied: false, status: "active", label: "none",
          metaTitle: "", metaDescription: "",
        };
        setData((old) => [...old, newRow]);
        setOriginalData((old) => [...old, newRow]);
      },
      removeRow: (rowIndex) => {
        setData((old) => old.filter((_row, index) => index !== rowIndex));
        setOriginalData((old) => old.filter((_row, index) => index !== rowIndex));
        setExpandedIndex(null);
      },
      removeSelectedRows: (selectedRows) => {
        setData((old) => old.filter((_row, index) => !selectedRows.includes(index)));
        setOriginalData((old) => old.filter((_row, index) => !selectedRows.includes(index)));
      },
    },
  });

  const columnCount = table.getCenterLeafColumns().length;
  const expandedRow =
    expandedIndex !== null ? table.getRowModel().rows.find((r) => r.index === expandedIndex) : null;

  return (
    <div className="w-full">
      {/* Scrollable table — panel is NOT inside this, so it can't stretch it */}
      <article className="w-full overflow-x-auto rounded-t-xl border border-gray-200 bg-white shadow-sm">
        <table className="w-full border-collapse text-sm">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="bg-gray-50">
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 border-b border-gray-200"
                  >
                    {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr
                key={row.id}
                className={`transition-colors ${
                  expandedIndex === row.index ? 'bg-pink-50/40' : 'hover:bg-gray-50/60'
                }`}
              >
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} className="px-4 py-3 align-middle border-b border-gray-100 text-gray-700">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={columnCount} align="right" className="px-4 py-3 bg-gray-50">
                <FooterCell table={table} />
              </th>
            </tr>
          </tfoot>
        </table>
      </article>

      {/* Expanded panel — full width block, outside the scroll region, wraps instead of overflowing */}
      {expandedRow && (
        <div className="w-full min-w-0 overflow-hidden rounded-b-xl border border-t-0 border-gray-200 bg-white shadow-sm">
          <VariantEditPanel
            rowData={expandedRow.original}
            onSave={(updated) => table.options.meta.updateRow(expandedRow.index, updated)}
            onCancel={() => table.options.meta.toggleExpand(expandedRow.index)}
          />
        </div>
      )}
    </div>
  );
};


// import { useState } from 'react';
// import './table.css';
// import {
//   flexRender,
//   getCoreRowModel,
//   useReactTable,
// } from '@tanstack/react-table';
// import { columns } from './columns';
// import { FooterCell } from '../Table/FooterCell';
// import { useProductVariantContext } from '../../context/hooks/useProductVariant';
// import { imageURL } from '../../Services/api/baseURL';

// export const Table = () => {

//   const { data, originalData, editedRows, setData, setOriginalData, setEditedRows, updateRow, pageCount } = useProductVariantContext();
//   const [pagination, setPagination] = useState({
//     pageIndex: 0,
//     pageSize: 10,
//   });

//   const table = useReactTable({
//     data,
//     columns,
//     pageCount: pageCount,
//     state: {
//       pagination: pagination,
//     },
//     onPaginationChange: setPagination,
//     getCoreRowModel: getCoreRowModel(),
//     manualPagination: true,

//     meta: {
//       editedRows,
//       setEditedRows,
//       revertData: (rowIndex, revert) => {
//         if (revert) {
//           setData((old) =>
//             old.map((row, index) =>
//               index === rowIndex ? originalData[rowIndex] : row
//             )
//           );
//         } else {
//           setOriginalData((old) =>
//             old.map((row, index) => (index === rowIndex ? data[rowIndex] : row))
//           );
//         }
//       },
//       // updateRow: (rowIndex) => {
//       //   updateRow(data[rowIndex].id, data[rowIndex]);
//       // },
//       // updateData: (rowIndex, columnId, value) => {
//       //   setData((old) =>
//       //     old.map((row, index) => {
//       //       if (index === rowIndex) {
//       //         return {
//       //           ...old[rowIndex],
//       //           [columnId]: value,
//       //         };
//       //       }
//       //       return row;
//       //     })
//       //   );
//       // },
//       updateRow: (rowIndex, updatedObject) => {
//         const updatedData = [...data];
//         updatedData[rowIndex] = { ...updatedObject };
//         console.log(updatedData,"6666666666666666666666666666666666666666666666666666666666666");
//         setData(updatedData); 
//         setOriginalData(updatedData);
//       },
//       updateData: (rowIndex, columnId, value) => {
//         setData((old) =>
//           old.map((row, index) => {
//             if (index === rowIndex) {
//               const updatedRow = {
//                 ...row,
//                 [columnId]: value,
//               };

//               // const purchasePrice = parseFloat(updatedRow.purchasePrice) || 0;
//               // const discount = parseFloat(updatedRow.discount) || 0;
//               // const quantity = parseFloat(updatedRow.quantity) || 1;

//               // const totalCost = purchasePrice * quantity;

//               // const totalDiscount = discount * quantity;

//               // updatedRow.finalSellingPrice = totalCost - totalDiscount;

//               return updatedRow;
//             }
//             return row;
//           })
//         );
//       },

//       addRow: () => {
//         const newRow = {
//           variantCode: "",
//           variantImage: null,
//           variantName: "",
//           sellingPrice: 0,
//           purchasePrice: 0,
//           quantity: 0,
//           discount: 0,
//           finalSellingPrice: 0,
//           isTopSellingProduct: false,
//           vol: "",
//           alcohol_percentage: 0,
//           isOfferApplied: false,
//           offers: [],
//           status : "active",
//           label: "none",
//           description : "",
//           metaTitle: "",
//           metaDescription: ""
//         };
//         const setFunc = (old) => [...old, newRow];
//         setData(setFunc);
//         setOriginalData(setFunc);
//       },
//       removeRow: (rowIndex) => {
//         const setFilterFunc = (old) =>
//           old.filter((_row, index) => index !== rowIndex);
//         setData(setFilterFunc);
//         setOriginalData(setFilterFunc);
//       },
//       removeSelectedRows: (selectedRows) => {
//         const setFilterFunc = (old) =>
//           old.filter((_row, index) => !selectedRows.includes(index));
//         setData(setFilterFunc);
//         setOriginalData(setFilterFunc);
//       },
//     },
//   });

//   return (
//     <article className='add_product_table_container'>
//       <table>
//         <thead>
//           {table.getHeaderGroups().map((headerGroup) => (
//             <tr key={headerGroup.id}>
//               {headerGroup.headers.map((header) => (
//                 <th key={header.id}>
//                   {header.isPlaceholder
//                     ? null
//                     : flexRender(
//                       header.column.columnDef.header,
//                       header.getContext()
//                     )}
//                 </th>
//               ))}
//             </tr>
//           ))}
//         </thead>
//         <tbody>
//           {table.getRowModel().rows.map((row) => (
//             <tr key={row.id}>
//               {row.getVisibleCells().map((cell) => (
//                 <>
//                   <td key={cell.id}>
//                     {/* Check if the cell type is 'image' */}
//                     {cell.column.columnDef.cell.type === 'image' ? (
//                       // Render image
//                       <img src={cell.row.original.variantImage ? imageURL + cell.row.original.variantImage : ""} alt="Imagei" />
//                     ) : (
//                       // Render other cell data
//                       flexRender(cell.column.columnDef.cell, cell.getContext())
//                     )}
//                   </td>
//                 </>
//                 // <td key={cell.id}>
//                 //   {flexRender(cell.column.columnDef.cell, cell.getContext())}
//                 // </td>

//               ))}
//             </tr>
//           ))}
//         </tbody>
//         <tfoot>
//           <tr>
//             <th colSpan={table.getCenterLeafColumns().length} align="right">
//               <FooterCell table={table} />
//             </th>
//           </tr>
//         </tfoot>
//       </table>
//     </article>
//   );
// };
